export enum Role {
  Admin = "admin",
  Customer_ZPL = "customer-zpl",
  Basic_ZPL = "basic-zpl",
  Customer_PIFSA = "customer-pifsa",
  Basic_BulkOrders = "basic-bulkorders",
  Customer_Switch = "customer-switch",
  Admin_Switch = "admin-switch",
  Review_BulkOrders = "review-bulkorders",
  Admin_BulkOrders = "admin-bulkorders",
  Clinic_Admin = "clinic-admin",
  HQ_Clinic_Admin = "hq-clinic-admin",
  HQ_Clinic_User = "hq-clinic-user",
  ZPL_Cinic_Admin = "zpl-clinic-admin",
}

export interface IRole {
  id: number;
  name: Role;
  description: string;
}